import { FilterTableFieldParamType, PrefixFilterValueType } from '../types';
import useDynamicSelector from './useDynamicSelector';

type SimpleFilterType = { [key: string]: string };
type SimpleOrFilterType = { or: { [key: string]: string }[] };

const useGetFilter = (paramFilter: { [key: string]: FilterTableFieldParamType }) => {
    const listGroupFilters = useDynamicSelector('table', 'listGroupFilters');

    if (!listGroupFilters) {
        return null;
    }

    const [firstGroupOfFilter] = Object.values(listGroupFilters);
    const filter_flexible: SimpleFilterType = {};
    const filter_flexible_or: SimpleOrFilterType = { or: [] };

    if (!firstGroupOfFilter) {
        return null;
    }

    let flagFilterDone = true;

    const listFilters = Object.values(firstGroupOfFilter.listFilters);
    for (const filter of listFilters) {
        if (!filter.filterDone) {
            flagFilterDone = false;
            break;
        }

        let prefixBefore: PrefixFilterValueType = '';
        let prefixAfter: PrefixFilterValueType = '';

        switch (filter.condition) {
            case 'has_any_value':
            case 'is_not':
                prefixBefore = '!';
                break;
            case 'starts_with':
                prefixBefore = '^';
                break;
            case 'ends_with':
                prefixBefore = '$';
                break;
            case 'contains':
                prefixBefore = '*';
                break;
            case 'from_list':
                prefixBefore = filter.value && paramFilter?.[filter.option.key].useAsString ? '*' : '';
                break;
            case 'contains_exact_word':
                prefixBefore = '~';
                break;
            case 'does_not_contain':
                prefixBefore = '!*';
                break;
            case 'before':
                prefixBefore = '1900-01-01..';
                break;
            case 'after':
                prefixAfter = '..2100-01-01';
                break;
                break;
            default:
                prefixBefore = '';
        }

        let value = '';

        switch (filter.condition) {
            case 'has_any_value':
            case 'is_unknown':
                value = '';
                break;
            default:
                value = `${filter.value || ''}`;
        }

        const getQueryFieldKey = () => {
            const additionalFilter = paramFilter?.[filter.option.key];

            if (additionalFilter && Object.keys(additionalFilter).length && filter.condition === 'from_list') {
                return additionalFilter.filterField;
            }

            return filter.option.key;
        };

        if (firstGroupOfFilter.condition === 'and') {
            if (filter_flexible[getQueryFieldKey()]) {
                filter_flexible[getQueryFieldKey()] += `,${prefixBefore}${value}${prefixAfter}`;
            } else {
                filter_flexible[getQueryFieldKey()] = `${prefixBefore}${value}${prefixAfter}`;
            }
        } else {
            const oldFilter = filter_flexible_or['or'].find((subFilter) => subFilter[getQueryFieldKey()]);

            if (oldFilter) {
                oldFilter[getQueryFieldKey()] += `|${prefixBefore}${value}${prefixAfter}`;
            } else {
                filter_flexible_or['or'].push({ [getQueryFieldKey()]: `${prefixBefore}${value}${prefixAfter}` });
            }
        }
    }

    if (flagFilterDone) {
        return firstGroupOfFilter.condition === 'and'
            ? JSON.stringify(filter_flexible)
            : JSON.stringify(filter_flexible_or);
    }

    return null;
};

export default useGetFilter;
